<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Crear Corte de Pago
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
          <div class="row mt-4">
            <div class="col-sm-6">
              <h4 class="font-info">Datos Generales</h4>
            </div>
          </div>
          <sys-form :inputs="monthly_cut_details"/>
        <!--end: Details -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'monthly_cuts' })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// import monthlyCutService from '@/services/monthly_cuts'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      monthly_cut_details: {
        cut_day: {
          name: 'Día de corte',
          hint: 'Día de corte',
          value: null,
          type: 'select',
          options: [
            { value: '7', text: 'Día 7' },
            { value: '15', text: 'Día 15' },
            { value: '21', text: 'Día 21' },
            { value: 'Ultimo', text: 'Ultimo día del mes' }
          ],
          validate: 'required'
        },
        month: {
          name: 'Mes',
          hint: 'Mes',
          value: '',
          type: 'number',
          min: 0,
          max: 12,
          validate: 'required'
        },
        year: {
          name: 'Año',
          hint: 'Año',
          value: '',
          type: 'number',
          min: 2018,
          max: 2200,
          validate: 'required'
        }
      }
    }
  },

  created: function () {},

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // let body = this.processForm(this.attachment_details)
          // let service = monthlyCutsService.post(body)
          //
          // this.sendForm(service).then(res => {
          //   this.$router.push({ name: 'monthly_cuts', props: { monthly_cuts: res } })
          // }).catch(err => {
          //   console.log(JSON.stringify(err))
          // })
        }
      })
    }
  },

  watch: {}
}
</script>

<style lang="scss" scoped>
.font-info {
  font-size: 1.5rem;
  color: var(--primary);
}
</style>



// WEBPACK FOOTER //
// src/components/monthly_cuts/MonthlyCutUpdate.vue